// @flow

import React from 'react';
import styled from 'styled-components';
import EmptyPage from './EmptyPage';
import type { PageProps } from './EmptyPage';
import { breakpoint } from '../utils/responsive';
import { grid } from '../utils/layout';

const ContentContainer = styled.div`
  ${grid()};
  ${breakpoint('medium')`
    margin-bottom: 1.5em;
  `};
  width: 100%;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
`;

const ContentBox = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  background-color: ${(props) => props.theme.ContentBoxColor};
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;

  ${breakpoint('medium')`
    box-shadow: 0 2px 6px 0 rgba(0,0,0,0.10);
    border-radius: 2px;
  `};
`;

const ContentContainerTopBar = styled.div`
  display: flex;
  align-items: center;
  ${breakpoint('medium')`
    min-Height: 1.5em;
  `};
`;

const Page = ({ renderContentTopbar, ...props }: PageProps) => {
  return (
    <EmptyPage {...props}>
      <ContentContainer>
        <ContentContainerTopBar>
          {renderContentTopbar && renderContentTopbar()}
        </ContentContainerTopBar>
        <ContentBox>{props.children}</ContentBox>
      </ContentContainer>
    </EmptyPage>
  );
};

Page.displayName = 'Page';

export default Page;
